<i18n lang='yml' src='../i18n/SkillsListing.yml'></i18n>
<template>
  <div>
    <div v-if="skillSet.name">
      <div class="heading-block mb-0 d-flex">
        <span class="badge yellow-bg" v-if="!skillSet.required">{{ $t('optional') }}</span>
        <h4>
          <span class="apprentice-name" v-if="allow_approval == 'true' && logbookData && logbookData.user_identity.external_identifiers">
            {{logbookData.user_identity.last_name}}, {{logbookData.user_identity.first_name}} ({{logbookData.user_identity.external_identifiers.sto_id}})
          </span>
          <span class="program-name">{{ skillSet.skill_set_code }} - {{ skillSet.name[locale] }}</span>
        </h4>
        <a v-if="edit =='true'" class='btn btn-sm btn-success ml-auto' :href="new_skill_path">
          <font-awesome-icon :icon="['fa', 'plus']"/>
          {{ $t('new_skill') }}
        </a>
      </div>
    </div>
    <div v-if="edit == 'true'">
      <h5 class="margin-top heading-page">
        {{$t('subheader')}}
      </h5>
      <p class="border-bottom"> {{$t('info')}}</p>
    </div>
    <div v-if="logbookData" class="heading-block post-meta top-shadow margin-bottom">  
      <ul class="list-inline list-annotation has-select-input"> 
        <li v-if="skillSet.progress" class="progress-component">
          <progress-bar 
              :percentage_value="skillSet.progress.percent" 
              :approved="skillSet.progress.completed_count" 
              :total="skillSet.progress.mandatory_count" 
              progress_message='progress-message-skills'
              type="success">
            </progress-bar>
        </li>
        <li class="ml-md-auto select-input-wrap">
          <div class="btn-group d-md-none ml-auto mr-2">
            <button v-if='!isAllSelected' class="btn btn-outline-secondary " href="#" @click="selectAll">
              {{ $t('select_all') }}
            </button>
            <button v-else class="btn btn-outline-secondary" href="#" @click="deselectAll">
              {{ $t('deselect_all') }}
            </button>
          </div>
          <div class="input-group input-group-sm">
            <select :disabled="isDisabled || isLocked" ref="sort" id="sort" :name="$t('sort')" class="select-dropdown custom-select form-control-sm" v-model="bulkUpdateStatus">
              <option :value="null" disabled>{{$t('update_status')}}</option>
              <option v-bind:key="item.value" v-for='item in skillStatuses' :value="item" :disabled="item.approve && allow_approval == 'false'">
                {{item.name}}
              </option>
            </select>
            <div class="input-group-append">
              <button :disabled="isDisabled || isLocked" class="btn btn-sm btn-success" href="#" @click="submitBulkStatusChange">
                {{ $t('save') }}
              </button>
            </div>
          </div>
          <div class="btn-group d-none d-md-block ml-2">
            <button v-if='!isAllSelected' :disabled="isLocked" class="btn btn-outline-secondary " href="#" @click="selectAll">
              {{ $t('select_all') }}
            </button>
            <button v-else :disabled="isLocked" class="btn btn-outline-secondary" href="#" @click="deselectAll">
              {{ $t('deselect_all') }}
            </button>
          </div>
        </li>  
        
      </ul>
    </div>
    <div v-if="logbookData" class="post-meta">
      <ul class="list-inline list-annotation"> 
        <li>{{ $t('status') }}
          <span class="status-badge">
            {{ skillSetStatus ? skillSetStatus.skill_set_status.name[locale] : $t('incomplete') }}
          </span>
        </li>
        <li>{{ $t('last_updated') }} {{ skillSetStatus ? formatDate(skillSetStatus.updated_at) : formatDate(logbookData.created_at)}}</li> 
      </ul>
    </div>
    <div class="post-meta">
      <div v-if="skillSet.description && skillSet.description[locale] && skillSet.description[locale].length > 0">
        <span class="sr-only" v-html="skillSet.description[locale]"></span>
        <more-less aria-hidden="true" :descriptionText="skillSet.description[locale]" /> 
      </div>
    </div>
        
    <filter-bar :filter_params = filter_params :filter_path = filter_path></filter-bar>
 
    <div class="alert alert-danger" role="alert" v-if="error">
      <h5>{{ $t('loading_error') }}</h5>
    </div>
   
    <div v-else-if="skillsList.length == 0">
      <div class="alert alert-warning" role="alert">
        {{noDataError}}
      </div>
    </div>
    <div class="content-block content-block-logbook" v-else :key="skill.id" v-for="skill in skillsList">
      <div class="post-meta">
        <ul class="list-inline list-annotation">
          <li class="list-inline-item pt-0" v-if="!skill.required">
            <span class="badge yellow-bg">{{ $t('optional') }}</span>
          </li>
          <li class="list-inline-item ml-auto" v-if="logbookData">
            <label :for="`select-skill-${skill.id}`" class="check-select">
              <input :disabled="isLocked || isApproved(skill)" :id="`select-skill-${skill.id}`" v-model="bulkUpdateSkills" type="checkbox" :value="skill.id" /> 
              <span>{{ $t('select') }}</span>
            </label>
          </li>
          <li class="list-inline-item ml-auto" v-if="edit =='true'">
            <div class="btn-group btn-group-sm">
              <a class="btn btn-outline-primary" :href="`skills/${skill.id}/edit`">
                <font-awesome-icon :icon="['fas', 'edit']" />
                {{ $t('edit') }}
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div class="post-view">
        <div class="post-content">
          <h5 :class="logbookData ? 'heading-content' : 'container-item-name'">
            {{ skill.skill_code }} - {{ skill.name[locale] }}
          </h5>
          <div class="fr-view description clearfix" v-if="skill.description[locale] && skill.description[locale].length > 0">          
            <span class="sr-only" v-html="skill.description[locale]"></span>
            <more-less :descriptionText="skill.description[locale]"/>
          </div>  
        </div>  
      </div>  
      <hr class="m-0"/>
      <div class="post-meta" v-if="logbookData">
        <ul class="list-inline list-annotation">
          <li>{{ $t('status') }} 
            <span class="status-badge">
              {{
                skillStatusMapping[`skill_${skill.id}_status`] && skillStatusMapping[`skill_${skill.id}_status`].name ? 
                skillStatusMapping[`skill_${skill.id}_status`].name : $t('not_started')
              }}
            </span>
          </li>
          <li>{{ $t('last_updated') }} {{ Object.keys(skill.status).length > 0 ? formatDate(skill.status.updated_at) : formatDate(logbookData.created_at)}}</li>
        </ul>
      </div>
  
      <div v-if="logbookData" class="post-tabs">
        <ul class="nav nav-tabs nav-tile" role="tablist">
          <li class="nav-item">
            <a class="nav-link" :href="`#skill-status-${skill.id}`">
              <font-awesome-icon :icon="['fas', 'cog']" />
              <span>{{$t('update_status')}}</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :href="`#history-${skill.id}`">
              <font-awesome-icon :icon="['fas', 'history']" />
              <span>{{$t('history')}}</span>
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane" :id="`skill-status-${skill.id}`">
            <Form ref="observer" v-slot="{ errors }" @submit="submitStatusChange($event, skill.id)" @invalid-submit="setErrorMessage">
                <div class="row">
                  <div class="form-group col-md-12 col-lg-6">
                    <label :for="skill.id">{{$t('skill_status')}}</label>
                      <select :disabled="isApproved(skill)" v-model="skillStatusMapping[`skill_${skill.id}_status`].value"  :id="skill.id" class="form-control">
                        <option disabled="disabled" :value="null">{{$t('update_status')}}</option>
                        <option :key="status.name" v-for="status in skillStatuses"  :value="status.value" :disabled="status.approve && allow_approval == 'false'">
                          {{status.name}}
                        </option>
                      </select>
                  </div>
                </div>
                <fieldset>
                  <legend>{{$t('add_trainer_details')}}</legend>
                  <div class="row">
                    <div class="form-group col-md-12 col-lg-6">
                      <label :for="`skill-${skill.id}-trainer-name`">{{$t('trainer_name')}} 
                        <i class="required" v-if="skillStatusMeansApprove(skillStatusMapping[`skill_${skill.id}_status`])">*</i>
                      </label>
                      <Field
                        :name="$t('trainer_name')" 
                        :rules="skillStatusMeansApprove(skillStatusMapping[`skill_${skill.id}_status`])? {required: true} :  '' "
                        v-slot="{ errors, field}"
                        v-model="skill.trainer_details['name']" >
                        <input 
                          :class="{'is-invalid': errors[0]}" 
                          :disabled="isApproved(skill, true) && skillStatusMeansApprove(skillStatusMapping[`skill_${skill.id}_status`])" 
                          class="form-control" 
                          :id="`skill-${skill.id}-trainer-name`" 
                          type="text"
                          v-bind="field"/>
                        <div class="invalid-feedback" :id="`${$t('sto_id')}_error`" v-if="errors[0]">
                          <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                          <span>{{ errors[0] }}</span> 
                        </div>
                      </Field>
                    </div>
                    <div class="form-group col-md-12 col-lg-6">
                      <label :for="`skill-${skill.id}-trainer-sto-id`">{{$t('sto_id')}}
                        <i class="required" v-if="skillStatusMeansApprove(skillStatusMapping[`skill_${skill.id}_status`]) && logbookData.training_standard.training_program.compulsory">*</i>
                      </label>
                      <Field
                        :name="$t('sto_id')" 
                        :rules="skillStatusMeansApprove(skillStatusMapping[`skill_${skill.id}_status`]) && logbookData.training_standard.training_program.compulsory ? {regex: ['numeric8', $t('sto_id').toLowerCase()]} : {regex: ['numeric8', $t('sto_id').toLowerCase(), true]}"
                        v-slot="{ errors, field}"
                        v-model="skill.trainer_details['sto_id']">
                        <input 
                          :class="{'is-invalid': errors[0]}" 
                          :disabled="isApproved(skill, true) && skillStatusMeansApprove(skillStatusMapping[`skill_${skill.id}_status`])" 
                          class="form-control control-md" 
                          :id="`skill-${skill.id}-trainer-sto-id`" 
                          type="text"
                          maxlength="8"
                          v-bind="field"/>
                        <span v-if="showStoIdError && errors.length == 0" class="invalid-feedback" :id="`skill-${skill.id}-trainer-sto-id-error`">
                          <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                          {{$t('invalid_sto_id')}}</span>
                        <div class="invalid-feedback" :id="`${$t('sto_id')}_error`" v-if="errors[0]" :set="showStoIdError = false">
                          <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                          <span>{{ errors[0] }}</span>
                        </div>
                      </Field>
                    </div>
                    <div class="form-group col-md-12 col-lg-6">
                      <label :for="`skill-${skill.id}-trainer-email`">{{$t('trainer_email')}}
                        <i v-if="skillStatusMeansApprove(skillStatusMapping[`skill_${skill.id}_status`])" class="required">*</i>
                      </label>
                      <Field
                        :name="$t('trainer_email')" 
                        :rules="skillStatusMeansApprove(skillStatusMapping[`skill_${skill.id}_status`])? {regex: ['email', $t('trainer_email').toLowerCase()]} : {regex: ['email', $t('trainer_email').toLowerCase(), true]}"
                        v-slot="{ errors, field }"
                        v-model="skill.trainer_details['email']"> 
                        <input 
                        :class="{'is-invalid': errors[0]}" 
                        :disabled="isApproved(skill, true) && skillStatusMeansApprove(skillStatusMapping[`skill_${skill.id}_status`])" 
                        class="form-control" :id="`skill-${skill.id}-trainer-email`" 
                        type="text" 
                        v-bind="field"/>
                        <div class="invalid-feedback" :id="`${$t('trainer_email')}_error`" v-if="errors[0]" >
                          <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                          <span>{{ errors[0] }}</span>
                        </div>
                      </Field> 
                    </div>
                    <div class="form-group col-md-6">
                      <div v-if="loading">
                        <loading-animation-vue :spinnerSize="40"></loading-animation-vue>
                      </div>
                    </div>
                    <div class="btn-row col-sm-12">
                      <button type="submit" :disabled="isLocked || isApproved(skill)" class="btn btn-sm btn-wide btn-success">
                        {{ $t('save') }}
                      </button>
                      <button v-if="hideDeleteTrainerDetails(skill)" :disabled="isLocked || isApproved(skill, true)" class="btn btn-sm btn-wide btn-danger" href="#" @click="deleteTrainerDetails($event, skill.id)">
                        {{ $t('delete_trainer_details') }}
                      </button>
                    </div>
                  </div>
                </fieldset>
            </Form> 
          </div>
        </div>
        <history-tab :item="skill" :locale="locale" :trainer_details="true"/>
      </div>
    </div>
  </div>
</template>
<script>
  import Main from '../../filter_bar/components/Main.vue';
  import LoadingAnimation from '../../shared/loader/components/LoadingAnimation.vue';
  import ProgressBar from '../../shared/progress_bar/ProgressBar.vue'
  import MoreLess from '../../shared/more_less_component/MoreLess.vue'
  import HistoryTab from './HistoryTab.vue'
  import '../../../javascripts/application/vee-validate-rules.js'
  import { sendAjaxRequest } from '../../shared/typescripts/ajax.ts'
  import { Form, Field } from 'vee-validate';
  import {formatDate} from '../../shared/typescripts/dates.ts'

  export default {
    props: ['locale', 'skill_set', 'skill_set_status', 'skills', 'filter_params','logbook_skill_statuses', 'logbook', 'skill_statuses', 
      'filter_path', 'new_skill_path', 'edit', 'skill_set_description', 'allow_approval'],
    components: {
        'filter-bar': Main,
        'loading-animation': LoadingAnimation,
        'history-tab': HistoryTab,
        'progress-bar':ProgressBar,
        Form,
        Field
    },
    data() {
      return {
        skillsList: [],
        skillSet: {},
        skillSetStatus: null,
        logbookSkillStatuses: [],
        currentUrl: window.location.href,
        skillStatuses: [],
        skillStatusMapping: {},
        logbookData: null,
        loading: false,
        error: false,
        bulkUpdateSkills: [],
        bulkUpdateStatus: null,
        isAllSelected: false,
        showStoIdError: false
      }
    },

    computed: {
      isDisabled: function() {
        return this.bulkUpdateSkills.length == 0;
      },

      isLocked: function() {
        return (this.skillSetStatus && this.skillSetStatus.skill_set_status.approved) || this.logbookData.status == 'approved';
      },

      noDataError: function() {
        let params;
        try {
          params = JSON.parse(this.filter_params)
          if (params){
            return params['search'].value ? this.$t('no_search') : this.$t('no_data') ;
          }
        }
        catch(err) {
          this.error = true;  
        }    
      }
    },
    created() {
      this.$i18n.locale = this.locale;
    },
    mounted() {
      // Here we are handling all of the mapping between the JSON objects we are getting as params to our variables
      // Some of them are dependent on whether we are inside of a logbook
      try {
        this.skillSet = JSON.parse(this.skill_set);
        this.skillsList = JSON.parse(this.skills) || [];
        this.logbookData = this.logbook ? JSON.parse(this.logbook) : null
        if(this.logbookData) {
          this.skillSetStatus = JSON.parse(this.skill_set_status) || null
          this.logbookSkillStatuses = JSON.parse(this.logbook_skill_statuses) || [];
          this.skillStatuses = JSON.parse(this.skill_statuses) || [];
          this.skillStatusMapping = this.initStatusMapping()
        }
      }
      catch(err) {
        this.error = true;
      }
    }, 

    methods: {
      // Determines whether a given skill status means approved
      // We do this in order to handle requiring trainer details if the selected status change makes the skill approved
      skillStatusMeansApprove(selected_skill_status) {
        var skill_status = this.skillStatuses.find((skillStatus) => {
          return skillStatus.value == selected_skill_status.value
        }) || null
        return skill_status ? skill_status.approve : false
      },

      // Handles displaying/hiding error messages on given trainer details fields
      // Takes in the skill we are showing the errors for, which field we are showing or hiding for and whether or not the error should be shown or hidden
      changeClassForField(skill, field, invalid = true) {
        var inline_error = document.getElementById(`skill-${skill.id}-trainer-${field}-error`)
        var input = document.getElementById(`skill-${skill.id}-trainer-${field}`)
        if(invalid) {
          input.classList.remove("is-valid")
          input.classList.add("is-invalid")
        }
        else {
          input.classList.remove("is-invalid")
          input.classList.add("is-valid")
        }
      },

      // Determines if a skill is approved
      // Used for disabling a variety of buttons that shouldn't be shown if a skill is approved
      isApproved(skill, skip_allow_approval=false) {
        return skill.status && skill.status.skill_status && skill.status.skill_status.approved && (skip_allow_approval || this.allow_approval == 'false')
      },

      // An array containing for each skill either the existing progress or null
      // Used to map the skills to progresses for viewing and saving
      initStatusMapping() {
        var result = {}
        this.skillsList.forEach((skill) => {
          // Map the status for this logbook to the skill
          skill.status = this.logbookSkillStatuses.find((logbookSkillStatus) => {
            return logbookSkillStatus.skill_id == skill.id
          }) || {}
          skill.trainer_details = {}
          // Copy the obkect to determine if we had trainer details before for remove trainer button
          if(skill.status.trainer_details) {
            Object.assign(skill.trainer_details, skill.status.trainer_details)
          }
          var status = skill.status ? this.skillStatuses.find((status) => {
            return status.value == skill.status.skill_status_id
          }): null
          // Map the skill_status to the dropdown option
          result[`skill_${skill.id}_status`] = status ? {
            name: status.name,
            value: status.value,
            approve: status.approved
          } : {name: null, value: null, approve: null}
        })
        return result
      },

      // We use this to add or remove skills from the selected bulk list
      addToSelected(skillId) {
        var index = this.bulkUpdateSkills.indexOf(skillId)
        if(index > -1) {
          this.bulkUpdateSkills.splice(index, 1);
        }
        else {
          this.bulkUpdateSkills.push(skillId)
        }
      },

      // Submits all of the selected skills to be updated with the selected status
      submitBulkStatusChange(e) {
        e.preventDefault();
        if(!this.bulkUpdateStatus || this.bulkUpdateSkills.length == 0) {
          return
        }
        this.loading = true
        var method= 'POST'
        var url= `bulk_skills_status_update`
        var data= {
          logbook_skill_statuses: {
            skill_status_id: this.bulkUpdateStatus.value,
            skills: this.bulkUpdateSkills,
            logbook_id: this.logbookData.id
          }
        }
        sendAjaxRequest(method, url, 'json', data, this.reloadWindow, this.throwError)
      },

      // Select all the skills on the current page and add them to our bulk update list
      selectAll(e) {
        e.preventDefault();
        this.skillsList.forEach((skill) => {
          if(this.bulkUpdateSkills.indexOf(skill.id) == -1 && !this.isApproved(skill)) {
            this.bulkUpdateSkills.push(skill.id);
          }
        })
        this.isAllSelected = true;
      },

      // Deselect all the skills on the current page and remove them from our bulk update list
      deselectAll(e) {
        e.preventDefault();
        this.bulkUpdateSkills = [];
        this.isAllSelected = false;
      },

      // Submits any change to the skill status
      submitStatusChange(values, skill_id) {
        this.loading = true
        let skill = this.skillsList.find((skill) => {
          return skill.id == skill_id
        })
        var method = skill.status ? "PUT" : "POST"
        var url = skill.status ? `skills/${skill_id}/logbook_skill_statuses/${skill.status.id}` : `skills/${skill_id}/logbook_skill_statuses`
        var data = {
          logbook_skill_status: {
            logbook_id: this.logbookData.id,
            skill_status_id: this.skillStatusMapping[`skill_${skill_id}_status`].value,
            skill_id: skill_id,
            trainer_details: skill.trainer_details
          }
        }
       sendAjaxRequest(method, url, 'json', data, (response) => {this.changeClassesForField(response, skill)});
      },

      // Deletes the trainer details for a chosen skill
      deleteTrainerDetails(event, skill_id) {
        event.preventDefault();
        if(!confirm(this.$t('confirm_trainer_details_delete'))) {
          return
        }
        this.loading = true
        var skill = this.skillsList.find((skill) => {
          return skill.id == skill_id
        })
        if(skill.status) {
          var method = "POST"
          var url = `skills/${skill_id}/logbook_skill_statuses/${skill.status.id}/delete_trainer_details`
          var data = {
            logbook_skill_status: {
              logbook_id: this.logbookData.id,
              skill_id: skill_id,
            }
          }
          sendAjaxRequest(method, url, 'json', data, this.ajaxSuccess, this.throwError)
        }
      },

      ajaxSuccess() {
        this.loading = false;
        return data;
      },

      reloadWindow() {
        window.location.reload();
      },

      throwError() {
        _vm.loading = false;
        console.log(message)
      },

      changeClassesForField(response, skill) {
        if(response.success) {
           window.location.reload();
          }
        else {
          Object.keys(response.errors).forEach((key) => {
            this.changeClassForField(skill, 'sto-id', false)

            if (key == 'sto-id') {
              this.showStoIdError = true
              this.changeClassForField(skill, key)
            }
          })
          this.loading = false
        }
      },

      //TODO: Revisit to standardize
      // Used for turning our system dates into a standard human readable format
      formatDate(dateString) {
        return formatDate(dateString)
      },

      // Hides the "delete trainer details" button if there are no details to delete
      hideDeleteTrainerDetails(skill) {
        if (skill.status.trainer_details && (skill.status.trainer_details['name'] || skill.status.trainer_details['email'] || skill.status.trainer_details['sto_id'])) {
          return true
        }
        else{
          return false
        }
      }
    },
  } 
</script>
